import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { LocationEditorData } from "../../state/Locations/EditorData";


const updateLocationsEditorData: Reducer<LocationEditorData> = (state: LocationEditorData = new LocationEditorData(), action: Action<ActionType, LocationEditorData>) => {
  switch (action.type) {
    case ActionType.LOCATIONS_EDITOR_DATA_RESET:
      return new LocationEditorData();
    case ActionType.LOCATIONS_EDITOR_DATA_FETCHED:
      return { ...state, locationData: action.data };
    case ActionType.LOCATIONS_EDITOR_DATA_COPIED:
      return { ...state, locationData: { ...action.data} };
    case ActionType.LOCATIONS_EDITOR_DATA_UPDATED:
      return { ...state, locationData: { ...state.locationData, ...action.data } };
    case ActionType.LOCATIONS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.LOCATIONS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    default:
      return state;
  }
};

export default updateLocationsEditorData;